
import {gsap, ScrollTrigger, SplitText} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";
export default class PageHome {
	constructor() {

		if( !document.body.classList.contains('home') ){
			return;
		}

		let banner = document.querySelector('.section-banner');
		let swiper = banner.querySelector('.swiper');
		let search = banner.querySelector('.banner-home-search');
		let title = banner.querySelectorAll('.title-banner');
		let subtitle = banner.querySelectorAll('.subtitle-banner');

		let options = {
			autoplay: {
				delay: 3000,
			},
			speed: 800,
			slidesPerView: "1",
			loop: true,
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			}
		};

		this.swiper = new Swiper(swiper, options);

		document.fonts.ready.then(() => {

			this.subTitle = SplitText.create(subtitle, {
				type: "lines",
				linesClass: "line",
				mask: "lines"
			});

			this.text = SplitText.create(title, {
				type: "lines",
				linesClass: "line",
				mask: "lines",
				onSplit: (self) => {
					gsap.set(title, {opacity: 1});
					gsap.set(subtitle, {opacity: 1});
					let tl = gsap.timeline();
					tl.to(self.lines, {
						y: 0,
						opacity: 1,
						stagger: 0.15
					}, '-=0.6');
					tl.to(this.subTitle.lines, {
						y: 0,
						opacity: 1,
						stagger: 0.15
					}, '-=0.6');
					tl.to(search, {
						y: 0
					}, '-=0.2');
				}
			});

		});

		const select = document.getElementById('url-region');
		const submit = document.getElementById('home-search-submit');
		submit.addEventListener("click", (e) => {
			e.preventDefault();
			const url = select.value;
			if (url) {
				window.location.href = url;
			} else {
				alert("Veuillez choisir une option");
			}
		});

	}
}
